export enum ChartRangeOptions {
  Year = 'year',
  Month = 'month',
  Week = 'week',
  Day = 'day',
  DayPerQuarter = 'day-per-quarter',
}
